import { Controller } from 'stimulus';
import createEvent from '@/helpers/createEvent';

const formatNumber = (number) => Math.round(parseInt(number, 10));

class RangeSlider extends Controller {
  connect() {
    this.noUiSlider = null;
    this.sliderInstance = null;
    this.isBooting = true;

    this.loadNoUiSlider();

    this.fromTarget.addEventListener('update', () => {
      this.sliderInstance.set([
        this.fromTarget.value,
        this.toTarget.value,
      ]);
    });
  }

  loadNoUiSlider() {
    import(/* webpackChunkName: "nouislider" */ 'nouislider')
      .then(({ default: module }) => {
        this.noUiSlider = module;
        this.renderSlider();
      });
  }

  renderSlider() {
    const min = parseInt(this.data.get('min'), 10);
    let max = parseInt(this.data.get('max'), 10);

    const [from, to] = [
      this.fromTarget.value,
      this.toTarget.value,
    ];

    if (min === max) {
      max += 1;
    }

    this.sliderInstance = this.noUiSlider.create(this.sliderTarget, {
      start: [from, to],
      connect: true,
      range: {
        min,
        max,
      },
    });

    this.sliderInstance.on('change', () => {
      this.handleChange();
    });

    this.sliderInstance.on('update', () => {
      this.handleUpdate();
    });

    this.handleChange();

    this.isBooting = false;
  }

  getValues() {
    const [from, to] = this.sliderInstance.get();
    return [formatNumber(from), formatNumber(to)];
  }

  getLabel(val) {
    return this.data.get('label-format').replace('[value]', val);
  }

  handleUpdate() {
    const [from, to] = this.getValues();

    this.fromTarget.value = from;
    this.toTarget.value = to;
  }

  handleChange() {
    this.handleUpdate();
    const [from, to] = this.getValues();

    this.fromTarget.value = from;
    this.toTarget.value = to;

    if (this.isBooting) {
      return;
    }

    createEvent(this.fromTarget, 'change');
  }
}

RangeSlider.targets = [
  'fromOutput',
  'toOutput',
  'from',
  'to',
  'slider',
];

export default RangeSlider;
